// extracted by mini-css-extract-plugin
export default {"tabDetail":"TabDetail_tabDetail__1THvb"};